import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from "react";
const InfoCircleOutlineIcon = _ref => {
  let {
      size = "20",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.42944 8.49968C7.65084 9.27862 6.61478 9.70728 5.51203 9.70728C4.40928 9.70728 3.37287 9.27862 2.59428 8.49968C1.80778 7.71318 1.375 6.67712 1.375 5.58228C1.375 4.48674 1.80778 3.45068 2.59428 2.66453C3.37287 1.88593 4.40928 1.45728 5.51203 1.45728C6.61478 1.45728 7.65084 1.88593 8.42944 2.66453C9.20012 3.43521 9.62466 4.47093 9.62466 5.58228C9.62466 6.69293 9.20012 7.72899 8.42944 8.49968ZM8.9155 2.17846C8.00697 1.26993 6.79834 0.769775 5.51203 0.769775C4.22572 0.769775 3.01675 1.26993 2.10822 2.17846C1.19178 3.09421 0.6875 4.30318 0.6875 5.58228C0.6875 6.86068 1.19178 8.06965 2.10822 8.98574C3.01675 9.89462 4.22572 10.3948 5.51203 10.3948C6.79834 10.3948 8.00697 9.89462 8.9155 8.98574C9.81612 8.08546 10.3122 6.87649 10.3122 5.58228C10.3122 4.28737 9.81612 3.0784 8.9155 2.17846Z",
    fill: color
  }), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 2.83252C5.21537 2.83252 4.98438 3.06352 4.98438 3.34814C4.98438 3.63277 5.21537 3.86377 5.5 3.86377C5.78497 3.86377 6.01562 3.63277 6.01562 3.34814C6.01562 3.06352 5.78497 2.83252 5.5 2.83252Z",
    fill: color
  }), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 4.46533C5.26281 4.46533 5.07031 4.65783 5.07031 4.89502V7.98877C5.07031 8.22596 5.26281 8.41846 5.5 8.41846C5.73719 8.41846 5.92969 8.22596 5.92969 7.98877V4.89502C5.92969 4.65783 5.73719 4.46533 5.5 4.46533Z",
    fill: color
  }));
};
export default InfoCircleOutlineIcon;